<template>
    <!--<div class="top-bar" v-if="this.$route.name == 'home'">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="top-contact">
                                <p class="mb-0">{{_T('Call Us')}}: 123 - 456 - 7890</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>-->
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TopBar',
  computed: {
    ...mapGetters([
      '_T'
    ]),
  },
}
</script>

<style lang="scss" scoped>
.top-bar {
  background-color: $light-border;
  padding: 0.625rem 0;
  p {
    margin-bottom: 0;
  }
  .top-social {
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: flex-end;
    ul {
      li {
        margin-left: 0.625rem;
        &:first-child {
          margin-left: 0;
        }
        i {
          color: $font-color;
          font-size: 1.125rem;
          transition: all 0.5s ease;
        }
        &:hover {
          i {
            color: $color-primary;
            transition: all 0.5s ease;
          }
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .top-bar {
    display: none;
}
}
</style>